import React from "react";
import PropTypes from "prop-types";
import { Component } from "react";
const cancelable = fn => {
  let cancelled;
  const wrapped = function () {
    if (!cancelled) {
      return fn(...arguments);
    }
  };
  wrapped.cancel = () => cancelled = true;
  return wrapped;
};
export default class ImageFallback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      useFallback: false
    };
  }
  componentDidMount() {
    var _this = this;
    const {
      fallback,
      src,
      onError,
      onLoad
    } = this.props;
    if (src !== undefined && fallback !== undefined) {
      this.image = new window.Image();
      this.image.src = src;
      this.image.onload = cancelable(function () {
        _this.setState(_ref => {
          let {
            useFallback
          } = _ref;
          return useFallback && {
            useFallback: false
          };
        });
        if (onLoad) onLoad(...arguments);
      });
      this.image.onerror = cancelable(function () {
        _this.setState(_ref2 => {
          let {
            useFallback
          } = _ref2;
          return !useFallback && {
            useFallback: true
          };
        });
        if (onError) onError(...arguments);
      });
    }
  }
  UNSAFE_componentWillUpdate(nextProps) {
    if (this.image && nextProps.src !== this.props.src) {
      this.image.src = nextProps.src;
    }
  }
  componentWillUnmount() {
    if (this.image) {
      this.image.onload.cancel();
      this.image.onerror.cancel();
    }
  }
  render() {
    const {
      children,
      fallback,
      src
    } = this.props;
    const {
      useFallback
    } = this.state;
    if ((!src || useFallback) && fallback) {
      return /*#__PURE__*/React.createElement("div", {
        role: "img",
        "aria-label": fallback
      }, fallback);
    }
    return children;
  }
}